import React from "react";
import { DashboardPage } from "@features/dashboard/DashboardPage";
import { DashboardPage as KPMGDashboardPage } from "@mandatorFeatures/kpmg/dashboard/DashboardPage";

export const dashboardComponents = {
  default: <DashboardPage />,
  "kpmg-germany": <KPMGDashboardPage />,
} as const;
